import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["InputComponent"];
import FilterOperatorValueInput from './FilterOperatorValueInput';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { memo } from 'react';
import FilterOperatorDateRangeInput from './FilterOperatorDateRangeInput';
import FilterOperatorDateRangeInputMoment from './FilterOperatorDateRangeInputMoment';
import FilterOperatorDateRangeInputMomentOperatorSelect from './FilterOperatorDateRangeInputMomentOperatorSelect';
import FilterOperatorDateRangeInputMomentWithTime from './FilterOperatorDateRangeInputMomentWithTime';
import styled from 'foundations-theming/utils';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const NumericalRangeContainer = styled.div.withConfig({
  displayName: "FilterOperatorHighValueInput__NumericalRangeContainer",
  componentId: "chjzop-0"
})(["display:flex;gap:8px;align-items:center;"]);
const FilterOperatorHighValueInput = props => {
  const {
      InputComponent
    } = props,
    rest = _objectWithoutPropertiesLoose(props, _excluded);
  if (InputComponent === FilterOperatorDateRangeInput) {
    return /*#__PURE__*/_jsx(FilterOperatorDateRangeInput, Object.assign({}, props));
  }
  if (InputComponent === FilterOperatorDateRangeInputMoment) {
    return /*#__PURE__*/_jsx(FilterOperatorDateRangeInputMoment, Object.assign({}, props));
  }
  if (InputComponent === FilterOperatorDateRangeInputMomentOperatorSelect) {
    return /*#__PURE__*/_jsx(FilterOperatorDateRangeInputMomentOperatorSelect, Object.assign({}, props));
  }
  if (InputComponent === FilterOperatorDateRangeInputMomentWithTime) {
    return /*#__PURE__*/_jsx(FilterOperatorDateRangeInputMomentWithTime, Object.assign({}, props));
  }
  return /*#__PURE__*/_jsxs(NumericalRangeContainer, {
    children: [/*#__PURE__*/_jsx(FilterOperatorValueInput, Object.assign({
      InputComponent: InputComponent,
      fieldName: "value"
    }, rest)), /*#__PURE__*/_jsx(FormattedMessage, {
      message: "customerDataFiltersUI.customerDataFilters.FilterOperatorInput.rangeAnd"
    }), /*#__PURE__*/_jsx(FilterOperatorValueInput, Object.assign({
      InputComponent: InputComponent,
      fieldName: "highValue"
    }, rest))]
  });
};
export default /*#__PURE__*/memo(FilterOperatorHighValueInput);